// extracted by mini-css-extract-plugin
module.exports = {"jobs":"styles_jobs__WknnU","jobs__filter":"styles_jobs__filter__WY81_","jobs__footer":"styles_jobs__footer__ZgsKt","jobs__link":"styles_jobs__link__xnZHv"};